import React, { useEffect, useState } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import ClaimYourSpot from "../../components/pages/coach/webinar/claim-your-spot";
import { coachPaths } from "../../routes/coach";
import { useNavigate } from "react-router-dom";
import EBookSlider from "../../components/slider/EBookSlider";
import { useDispatch, useSelector } from "react-redux";
import { getAllEBooksListCoach } from "../../redux/features/coach/actions/authAction";
import Loader from "../../components/loader";
import ClientSlider from "../../components/slider/ClientSlider";

const WebinarLandingPage = () => {
  const { isLoading, getAllEBookList } = useSelector(
    (state) => state.coach.auth
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scroll(0, 0);
    dispatch(getAllEBooksListCoach({ payload: "?content_type=eBook" }));
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <MenuLayout>
        <section class="ct_workshop_banner_main mt-5">
          <div class="ct_overlay_imgaes">
            <img src="assets/img/workshop_overlay_img_1.png" alt="" />
            <img src="assets/img/workshop_overlay_img_2.png" alt="" />
            <img
              src="assets/img/workshop_overlay_img_3.jpg"
              alt=""
              style={{ maxWidth: "220px" }}
            />
            <img
              src="assets/img/workshop_overlay_img_4.png"
              alt=""
              style={{ maxWidth: "220px" }}
            />
            <img src="assets/img/workshop_overlay_img_5.jpg" alt="" />
            <img src="assets/img/workshop_overlay_img_6.png" alt="" />
          </div>
          <div class="container-fluid">
            <div class="row">
              <div
                class="col-md-6 mx-auto ct_overview_page_pt_res_mnage"
                style={{ paddingTop: "251px" }}
              >
                <div
                  class="text-center "
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <h2
                    class="ct_fs_50_new  mb-4 ct_darkblue_text mx-auto"
                    style={{ maxWidth: "606px" }}
                  >
                    Your Growth Starts with the{" "}
                    <span class="ct_yellow_text"> Right </span>
                    Coach
                  </h2>
                  <p class="mb-0 ct_fs_20">
                    Transform your ideas into action with tailored coaching for
                    business, leadership, and personal success.
                  </p>
                  <div class="text-center mt-4">
                    <a
                      class="ct_yellow_btn ct_fit_content mx-auto px-5"
                      onClick={() => navigate(coachPaths.FindCoach)}
                    >
                      Get Coached
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          class="pt-5"
          data-aos="fade-top"
          data-aos-duration="1500"
          style={{ marginTop: "200px" }}
        >
          <h4 class="ct_fs_24_new  text-center">
            Join the 1,200+ companies growing with us{" "}
          </h4>
          <ClientSlider />
        </section>
        <section
          class="mt-5 ct_sky_blue_bg ct_px_40 "
          style={{ paddingTop: "150px" }}
        >
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 text-center">
                <p
                  className="ct_fs_24_new mx-auto pb-5"
                  style={{ maxWidth: "1130px" }}
                >
                  Explore six coaching paths designed to support your growth
                  whether you’re launching a business, leading a team, or
                  leveling up personally or professionally.
                </p>
              </div>
            </div>
            <div class="row mt-4">
              <div
                class="col-md-6 mb-4"
                data-aos="fade-right"
                data-aos-duration="1500"
              >
                <div class="ct_white_bg_card">
                  <div>
                    <div class="ct_icon  mb-3">
                      <img
                        src="assets/img/icon-park-solid_arrow-keys.png"
                        alt=""
                      />
                    </div>
                    <div>
                      <h4 class="ct_fs_22 ct_grey_text">Founder Coaching</h4>
                      <p
                        class="mb-0 ct_fs_18 ct_darkblue_text"
                        style={{ maxWidth: "532px" }}
                      >
                        Gain clarity, confidence, and structure to build,
                        launch, or grow your business from the ground up.
                      </p>
                    </div>
                  </div>
                  <div class="mt-auto pt-4">
                    <a
                      class="ct_yellow_btn  ct_fit_content ct_h_48 ct_outline_yellow"
                      onClick={() => navigate(coachPaths.FounderCoaching)}
                    >
                      Learn More <i class="fa-solid fa-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="col-md-6 mb-4"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <div class="ct_white_bg_card">
                  <div>
                    <div class="ct_icon  mb-3">
                      <img
                        src="assets/img/material-symbols_mountain-flag.png"
                        alt=""
                      />
                    </div>
                    <div>
                      <h4 class="ct_fs_22 ct_grey_text">
                        Executive & Leadership Coaching
                      </h4>
                      <p
                        class="mb-0 ct_fs_18 ct_darkblue_text"
                        style={{ maxWidth: "532px" }}
                      >
                        Strengthen your leadership skills, make better
                        decisions, and lead with confidence at every level.
                      </p>
                    </div>
                  </div>
                  <div class="mt-auto pt-4">
                    <a
                      class="ct_yellow_btn  ct_fit_content ct_h_48 ct_outline_yellow"
                      onClick={() => navigate(coachPaths.LeadershipCoaching)}
                    >
                      Learn More <i class="fa-solid fa-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="col-md-6 mb-4"
                data-aos="fade-right"
                data-aos-duration="1500"
              >
                <div class="ct_white_bg_card">
                  <div>
                    <div class="ct_icon  mb-3">
                      <img
                        src="assets/img/icon-park-solid_arrow-keys_4.png"
                        alt=""
                      />
                    </div>
                    <div>
                      <h4 class="ct_fs_22 ct_grey_text">Team Coaching</h4>
                      <p
                        class="mb-0 ct_darkblue_text ct_fs_18"
                        style={{ maxWidth: "532px" }}
                      >
                        Align your team, improve communication, and build a
                        culture of trust and collaboration.
                      </p>
                    </div>
                  </div>
                  <div class="mt-auto pt-4">
                    <a
                      class="ct_yellow_btn  ct_fit_content ct_h_48 ct_outline_yellow"
                      onClick={() => navigate(coachPaths.TeamTeaching)}
                    >
                      Learn More <i class="fa-solid fa-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="col-md-6 mb-4"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <div class="ct_white_bg_card">
                  <div>
                    <div class="ct_icon  mb-3">
                      <img src="assets/img/ion_speedometer.png" alt="" />
                    </div>
                    <div>
                      <h4 class="ct_fs_22 ct_grey_text">
                        Performance Coaching
                      </h4>
                      <p
                        class="mb-0 ct_fs_18 ct_darkblue_text"
                        style={{ maxWidth: "532px" }}
                      >
                        Break through blocks, stay accountable, and maintain
                        momentum toward your personal and professional goals.
                      </p>
                    </div>
                  </div>
                  <div class="mt-auto pt-4">
                    <a
                      class="ct_yellow_btn  ct_fit_content ct_h_48 ct_outline_yellow"
                      onClick={() => navigate(coachPaths.PerformanceCoaching)}
                    >
                      Learn More <i class="fa-solid fa-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="col-md-6 mb-4"
                data-aos="fade-right"
                data-aos-duration="1500"
              >
                <div class="ct_white_bg_card">
                  <div>
                    <div class="ct_icon  mb-3">
                      <img src="assets/img/Icon_business.png" alt="" />
                    </div>
                    <div>
                      <h4 class="ct_fs_22 ct_grey_text">
                        Strategic Business Coaching
                      </h4>
                      <p
                        class="mb-0 ct_fs_18 ct_darkblue_text"
                        style={{ maxWidth: "532px" }}
                      >
                        Get expert guidance to scale your business with smarter
                        systems, better planning, and stronger execution.
                      </p>
                    </div>
                  </div>
                  <div class="mt-auto pt-4">
                    <a
                      class="ct_yellow_btn  ct_fit_content ct_h_48 ct_outline_yellow"
                      onClick={() => navigate(coachPaths.BusinessCoaching)}
                    >
                      Learn More <i class="fa-solid fa-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="col-md-6 mb-4"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <div class="ct_white_bg_card">
                  <div>
                    <div class="ct_icon mb-3">
                      <img src="assets/img/ph_person-fill.png" alt="" />
                    </div>
                    <div>
                      <h4 class="ct_fs_22 ct_grey_text">Personal Coaching</h4>
                      <p
                        class="mb-0 ct_fs_18 ct_darkblue_text"
                        style={{ maxWidth: "532px" }}
                      >
                        Find clarity, build self-trust, and unlock the
                        confidence you need to move forward in life or career.
                      </p>
                    </div>
                  </div>
                  <div class="mt-auto pt-4">
                    <a
                      class="ct_yellow_btn  ct_fit_content ct_h_48 ct_outline_yellow"
                      onClick={() => navigate(coachPaths.PersonalCoaching)}
                    >
                      Learn More <i class="fa-solid fa-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="ct_py_70  ct_px_40">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div
                class="col-lg-3 mb-4 mb-lg-0"
                data-aos="fade-right"
                data-aos-duration="1500"
              >
                <div class="ct_how_work_img">
                  <img src="assets/img/coach_works_img.png" alt="" style={{objectPosition:"left"}} />
                </div>
              </div>
              <div
                class="col-lg-9 mb-4 mb-lg-0 ps-lg-5"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <div class="ct_how_work_content">
                  <h4 class="ct_fs_24_new ct_orange_text">
                    How CoachHUB Works?
                  </h4>
                  <h3 class="ct_fs_32 ct_darkblue_text ">
                    Get the right coach, the right plan, and start seeing
                    results.
                  </h3>
                </div>
                <div class="row mt-5">
                  <div class="col-lg-4 col-md-6 mb-4 mb-lg-0  ">
                    <div class="ct_how_work_card">
                      <img
                        src="assets/img/ri_find-replace-fill.png"
                        alt=""
                        style={{ width: "40px", height: "40px" }}
                      />
                      <div className="mt-3">
                        <h4 class="ct_fs_20 mb-3  ct_darksky_blue_text ct_fw_600">
                          Choose Your Coach
                        </h4>
                        <p class="mb-0" style={{ maxWidth: "330px" }}>
                          Choose from six growth-focused coaching paths tailored
                          to your needs..
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 mb-4 mb-lg-0  ">
                    <div class="ct_how_work_card">
                      <img
                        src="assets/img/fa6-solid_handshake.png"
                        alt=""
                        style={{ width: "40px", height: "40px" }}
                      />
                      <div className="mt-3">
                        <h4 class="ct_fs_20 mb-3  ct_darksky_blue_text ct_fw_600">
                          Select a Plan or Workshop
                        </h4>
                        <p class="mb-0" style={{ maxWidth: "230px" }}>
                          Find a package that fits your goals, schedule, and
                          budget.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 mb-4 mb-lg-0  ">
                    <div class="ct_how_work_card">
                      <img
                        src="assets/img/uim_bag.png"
                        alt=""
                        style={{ width: "40px", height: "40px" }}
                      />
                      <div className="mt-3">
                        <h4 class="ct_fs_20 mb-3 ct_darksky_blue_text ct_fw_600">
                          Book & Begin
                        </h4>
                        <p class="mb-0" style={{ maxWidth: "230px" }}>
                          Schedule your session and start working with your
                          coach.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          class="ct_looking_for_work_bg"
          style={{ paddingBlock: "100px" }}
          data-aos="fade-left"
          data-aos-duration="1500"
        >
          <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
            <div class="text-white">
              <h4 class="ct_fs_36 mb-3">Ready to Accelerate Your Growth?</h4>
              <p
                class="mb-0 ct_fs_18"
                style={{ maxWidth: "684px", opacity: "0.9" }}
              >
                Find a coach who understands your goals, challenges, and next
                steps. Whether you're launching a business, building confidence,
                or scaling your team the right coach is just a click away.
              </p>
            </div>
            <div class="ct_flex_shrink_0">
              <a
                class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(coachPaths?.WebinarData);
                }}
              >
                View Events
              </a>
            </div>
          </div>
        </section>
        <section class="ct_py_100  ct_px_40">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="text-center">
                  <h4 class="ct_fs_40 ct_yellow_text mb-4">
                    Coaching Packages Designed for Every Stage
                  </h4>
                  <p class="mb-0 ct_fs_24_new ct_darkblue_text">
                    Choose a coaching pack that fits your goals — whether you're
                    launching, scaling, or seeking clarity.
                  </p>
                </div>
              </div>
            </div>
            <div
              class="row mt-5 pt-4"
              data-aos="fade-down"
              data-aos-duration="1500"
            >
              <div class="col-md-12">
                <ul
                  class="nav nav-pills mb-3 ct_custom_tabs w-100"
                  id="pills-tab"
                  role="tablist"
                >
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="pills-Founder-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-Founder"
                      type="button"
                      role="tab"
                      aria-controls="pills-Founder"
                      aria-selected="true"
                    >
                      Founder
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-Executive-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-Executive"
                      type="button"
                      role="tab"
                      aria-controls="pills-Executive"
                      aria-selected="false"
                      tabindex="-1"
                    >
                      Executive & Leadership
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-Team_Coaching-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-Team_Coaching"
                      type="button"
                      role="tab"
                      aria-controls="pills-Team_Coaching"
                      aria-selected="false"
                      tabindex="-1"
                    >
                      Team
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-Performance-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-Performance"
                      type="button"
                      role="tab"
                      aria-controls="pills-Performance"
                      aria-selected="false"
                      tabindex="-1"
                    >
                      Performance
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-Strategic-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-Strategic"
                      type="button"
                      role="tab"
                      aria-controls="pills-Strategic"
                      aria-selected="false"
                      tabindex="-1"
                    >
                      Strategic Business
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-Personal_Coaching-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-Personal_Coaching"
                      type="button"
                      role="tab"
                      aria-controls="pills-Personal_Coaching"
                      aria-selected="false"
                      tabindex="-1"
                    >
                      Personal
                    </button>
                  </li>
                </ul>
                <div class="tab-content mt-5" id="pills-tabContent">
                  <div
                    class="tab-pane fade active show"
                    id="pills-Founder"
                    role="tabpanel"
                    aria-labelledby="pills-Upcoming-tab"
                  >
                    <div class="row">
                      <div class="col-lg-8 mb-4 mb-lg-0">
                        <div class="ct_">
                          <h4 class="ct_fs_32 ct_orange_text ">
                            Founder Packages
                          </h4>
                          <p
                            class="mb-0 ct_fs_20"
                            style={{ maxWidth: "768px" }}
                          >
                            Designed for solopreneurs and founders who want to
                            turn great ideas into tangible results with focus,
                            structure, and drive.
                          </p>
                        </div>
                        <div class="row mt-5">
                          <div class="col-lg-6  mb-4 mb-lg-0">
                            <div
                              class="ct_pricing_card"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                    Clarity Pack
                                  </p>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">$259</h2>
                                  <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                    For solopreneurs
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    2 × 60-min sessions
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Business model snapshot
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    30-day focus plan
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Email check-in
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto pt-5">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Your Coach
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 mb-4 mb-lg-0">
                            <div
                              class="ct_pricing_card"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                                    <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                      Launch Pack
                                    </p>
                                    <span
                                      class="ct_most_popular_badge ct_flex_shrink_0"
                                      style={{
                                        backgroundColor: "var(--yellow) ",
                                        color: "var(--darkblue)",
                                      }}
                                    >
                                      Most Popular
                                    </span>
                                  </div>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">$599</h2>
                                  <p
                                    class="mb-0 mt-2 ct_fs_20 ct_orange_text"
                                    style={{ maxWidth: "261px" }}
                                  >
                                    For early-stage entrepreneurs.
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    5 × sessions
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Vision, offer & strategy mapping
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Confidence + mindset coaching
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Resource toolkit (Notion templates, guides)
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Your Coach
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 mb-4 mb-lg-0 ps-lg-3">
                        <div class="ct_about_img">
                          <img
                            src="assets/img/Rectangle_4187_new_233.png"
                            alt=""
                            class="ct_img_h_641"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="pills-Executive"
                    role="tabpanel"
                    aria-labelledby="pills-Executive-tab"
                  >
                    <div class="row">
                      <div class="col-lg-8 mb-4 mb-lg-0">
                        <div class="ct_">
                          <h4 class="ct_fs_32 ct_darksky_blue_text ">
                            Executive & Leadership Packages
                          </h4>
                          <p class="mb-0 ct_fs_20">
                            Strengthen your leadership skills, make better
                            decisions, and lead with confidence at every level.
                          </p>
                        </div>
                        <div class="row mt-5">
                          <div class="col-lg-6  mb-4 mt-lg-4 mb-lg-0">
                            <div
                              class="ct_pricing_card"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <p class="mb-2 ct_fs_24_new ct_yellow_text">
                                    Focus Pack
                                  </p>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">
                                    $250{" "}
                                  </h2>
                                  <p class="mb-0 mt-2 ct_fs_20 ct_darksky_blue_text">
                                    For managers
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    2 coaching sessions + leadership
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    style test
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Delegation & time audit
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Action checklist
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto pt-5">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Plan
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 mb-4 mb-lg-0">
                            <div
                              class="ct_pricing_card"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                                    <p class="mb-2 ct_fs_24_new ct_yellow_text">
                                      Leadership Lab
                                    </p>
                                    <span class="ct_most_popular_badge ct_flex_shrink_0">
                                      Most Popular
                                    </span>
                                  </div>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">$520</h2>
                                  <p class="mb-0 mt-2 ct_fs_20 ct_darksky_blue_text">
                                    For directors, and C-level professionals
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    6 sessions over 8 weeks
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Communication & conflict
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    coaching
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Team & process alignment Priority
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    leadership plan
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Plan
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 mb-4 mb-lg-0 ps-lg-3">
                        <div class="ct_about_img">
                          <img
                            src="assets/img/Rectangle_4187_12.png"
                            alt=""
                            class="ct_img_h_641"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="pills-Team_Coaching"
                    role="tabpanel"
                    aria-labelledby="pills-Team_Coaching-tab"
                  >
                    <div class="row">
                      <div class="col-lg-8 mb-4 mb-lg-0">
                        <div class="ct_">
                          <h4 class="ct_fs_32 ct_yellow_text ">
                            Team Packages
                          </h4>
                          <p class="mb-0 ct_fs_20">
                            Align your team, improve communication, and build a
                            culture of trust and collaboration.
                          </p>
                        </div>
                        <div class="row mt-5">
                          <div class="col-lg-6 mt-lg-4  mb-4 mb-lg-0">
                            <div
                              class="ct_pricing_card"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                    Team Pulse Workshop
                                  </p>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">
                                    $320{" "}
                                  </h2>
                                  <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                    For small teams seeking cohesion
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    1 group session (up to 4 members)
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Role clarity, shared values &
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    challenges
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Team feedback & strategy boar
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto pt-5">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Plan
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 mb-4 mb-lg-0">
                            <div
                              class="ct_pricing_card"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                                    <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                      Team Evolution Program
                                    </p>
                                    <span
                                      class="ct_most_popular_badge ct_flex_shrink_0"
                                      style={{
                                        backgroundColor: "var(--yellow) ",
                                        color: "var(--darkblue)",
                                      }}
                                    >
                                      Most Popular
                                    </span>
                                  </div>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">$400</h2>
                                  <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                    For small teams seeking clarity &
                                    collaboration
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    3 workshops + 2 leader 1:1s
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Communication & accountability
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    systems
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Execution roadmap
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Follow-up session after 30 days
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Plan
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 mb-4 mb-lg-0 ps-lg-3">
                        <div class="ct_about_img">
                          <img
                            src="assets/img/Rectangle_4187_new_one_223.png"
                            alt=""
                            class="ct_img_h_641"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="pills-Performance"
                    role="tabpanel"
                    aria-labelledby="pills-Performance-tab"
                  >
                    <div class="row">
                      <div class="col-lg-8 mb-4 mb-lg-0">
                        <div class="ct_">
                          <h4 class="ct_fs_32 ct_sky_blue_text ">
                            Performance Packages
                          </h4>
                          <p
                            class="mb-0 ct_fs_20"
                            style={{ maxWidth: "787px" }}
                          >
                            Break through blocks, stay accountable, and maintain
                            momentum toward your personal and professional
                            goals.
                          </p>
                        </div>
                        <div class="row mt-5">
                          <div class="col-lg-6  mb-4 mb-lg-0">
                            <div
                              class="ct_pricing_card p-3"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                    Boost Pack
                                  </p>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">
                                    $220{" "}
                                  </h2>
                                  <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                    For individuals or teams who want to boost
                                    productivity and sharpen performance.
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    2 × coaching sessions
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Personal productivity reset
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Energy + habit tracker
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto pt-5">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Plan
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 mb-4 mb-lg-0">
                            <div
                              class="ct_pricing_card p-3"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                                    <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                      Performance Sprint
                                    </p>
                                    <span
                                      class="ct_most_popular_badge ct_flex_shrink_0"
                                      style={{
                                        backgroundColor: "var(--yellow) ",
                                        color: "var(--darkblue)",
                                      }}
                                    >
                                      Most Popular
                                    </span>
                                  </div>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">$480</h2>
                                  <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                    For high performers and leaders ready to
                                    sustain growth and reach new potential.
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    6 sessions
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Mindset, resilience, and focus
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Goal system setup
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    WhatsApp accountability
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Plan
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 mb-4 mb-lg-0 ps-lg-3">
                        <div class="ct_about_img">
                          <img
                            src="assets/img/Rectangle_418_258963.png"
                            alt=""
                            class="ct_img_h_641"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="pills-Strategic"
                    role="tabpanel"
                    aria-labelledby="pills-Strategic-tab"
                  >
                    <div class="row">
                      <div class="col-lg-8 mb-4 mb-lg-0">
                        <div class="ct_">
                          <h4 class="ct_fs_32 ct_orange_text ">
                            Strategic Business Packages
                          </h4>
                          <p
                            class="mb-0 ct_fs_20"
                            style={{ maxWidth: "768px" }}
                          >
                            Get expert guidance to scale your business with
                            smarter systems, better planning, and stronger
                            execution.
                          </p>
                        </div>
                        <div class="row mt-5">
                          <div class="col-lg-6  mb-4 mb-lg-0">
                            <div
                              class="ct_pricing_card"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                    90-Day Roadmap
                                  </p>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">
                                    $380{" "}
                                  </h2>
                                  <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                    For entrepreneurs or teams seeking clarity
                                    and strategic direction.
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    3 sessions business review,
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    strategy, follow-up
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Funnel & positioning review
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    KPI setup
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto pt-5">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Plan
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 mb-4 mb-lg-0">
                            <div
                              class="ct_pricing_card"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                                    <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                      ScaleUp Plan
                                    </p>
                                    <span
                                      class="ct_most_popular_badge ct_flex_shrink_0"
                                      style={{
                                        backgroundColor: "var(--yellow) ",
                                        color: "var(--darkblue)",
                                      }}
                                    >
                                      Most Popular
                                    </span>
                                  </div>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">$599</h2>
                                  <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                    For founders and teams ready to scale with
                                    structure, confidence, and purpose.
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    8 strategy sessions over 3 months
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Revenue model optimization
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Team & process planning
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Strategic calendar
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Plan
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 mb-4 mb-lg-0 ps-lg-3">
                        <div class="ct_about_img">
                          <img
                            src="assets/img/Rectangle_4187_85.png"
                            alt=""
                            class="ct_img_h_641"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="pills-Personal_Coaching"
                    role="tabpanel"
                    aria-labelledby="pills-Personal_Coaching-tab"
                  >
                    <div class="row">
                      <div class="col-lg-12 mb-4 mb-lg-0">
                        <div class="">
                          <h4 class="ct_fs_32 ct_yellow_text ">
                            Personal Packages
                          </h4>
                          <p class="mb-0 ct_fs_20">
                            Find clarity, build self-trust, and unlock the
                            confidence you need to move forward in life or
                            career.
                          </p>
                        </div>
                        <div class="row mt-5">
                          <div class="col-lg-4  mb-4 mb-lg-0">
                            <div
                              class="ct_pricing_card"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                    Awareness Pack
                                  </p>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">
                                    $160{" "}
                                  </h2>
                                  <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                    For individuals seeking clarity, direction,
                                    and personal growth.
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    2 sessions
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Values & life clarity session
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Habit & mindset reset plan
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Support email after 2 week
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto pt-5">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Plan
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4 mb-4 mb-lg-0">
                            <div
                              class="ct_pricing_card"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                                    <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                      Breakthrough Pack
                                    </p>
                                    <span
                                      class="ct_most_popular_badge ct_flex_shrink_0"
                                      style={{
                                        backgroundColor: "var(--yellow) ",
                                        color: "var(--darkblue)",
                                      }}
                                    >
                                      Most Popular
                                    </span>
                                  </div>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">$400</h2>
                                  <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                    For individuals ready to gain momentum and
                                    align purpose with action.
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    5 sessions
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Confidence & decision-making
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    support
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Purpose alignment
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Life systems mapping
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Plan
                                </a>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-4  mb-4 mb-lg-0">
                            <div
                              class="ct_pricing_card"
                              style={{ borderColor: "#8ECAE6" }}
                            >
                              <div>
                                <div class="ct_pricing_title mt-3 text-start">
                                  <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                                    Transformation Pack
                                  </p>
                                  <h2 class="ct_fs_44  mb-0 ct_fw_600">
                                    $680{" "}
                                  </h2>
                                  <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                                    For individuals ready to elevate their
                                    identity, mindset, and leadership.
                                  </p>
                                </div>
                                <ul class="ct_mt_30 mb-4 mt-4">
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    8 sessions over 3 months
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Deep identity work, beliefs, and
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    leadership
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    Routine & energy optimization
                                  </li>
                                  <li className="ct_fs_18">
                                    <i
                                      class="fa-solid fa-check"
                                      style={{ backgroundColor: "#023047" }}
                                    ></i>{" "}
                                    WhatsApp + accountability tracker
                                  </li>
                                </ul>
                              </div>
                              <div class="mt-auto pt-5">
                                <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                  Choose Plan
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          class="ct_looking_for_work_bg ct_looking_for_work_bg_left"
          data-aos="fade-right"
          data-aos-duration="1500"
        >
          <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
            <div class="text-white">
              <h4 class="ct_fs_36 mb-3">Monetize Your Expertise on CoachHUB</h4>
              <p class="mb-0 ct_fs_20" style={{ maxWidth: "671px" }}>
                Share your expertise through e-books, personalized coaching, and
                events and grow your global reach with CoachHUB.
              </p>
            </div>
            <div class="ct_flex_shrink_0">
              <a
                class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                onClick={() => navigate(coachPaths.BecomeCoach)}
              >
                Join as Coach
              </a>
            </div>
          </div>
        </section>
        {getAllEBookList?.length != 0 && (
          <section class="ct_coach_created_bg ct_px_40 ">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 text-center">
                  <h2 class="ct_fs_40 ct_orange_text mb-3">
                    Coach-Created eBooks, Real-World Wisdom
                  </h2>
                  <p className="ct_fs_24_new ct_darkblue_text">
                    Unlock actionable insights and tools from coaches who turn
                    everyday challenges into growth stories.
                  </p>
                </div>
                <EBookSlider getAllEBookList={getAllEBookList} />
                {/* <div
                class="col-md-12 mt-5"
                data-aos="fade-down"
                data-aos-duration="1500"
              >
                <div class="owl-carousel owl-theme ct_coach_created_slider">
                  <div class="item">
                    <figure class="mb-0 ct_coach_created_card">
                      <div
                        class="ct_coach_created_img"
                        style={{ aspectRatio: "auto" }}
                      >
                        <img src="assets/img/book_1.png" alt="" />
                      </div>
                      <figcaption class="mt-3">
                        <div class="d-flex align-items-center gap-2 justify-content-between mb-2">
                          <p class="mb-0 ct_fs_18">From Idea to Action</p>
                          <p class="mb-0 d-flex align-items-center gap-1">
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                          </p>
                        </div>
                        <p class="mt-1 mb-0 ct_fs_14 ct_darkblue_text ct_fw_600">
                          By Jeffrey Walters / Founder Coach
                        </p>
                        <p class="mt-1 ct_fs_16">
                          A step-by-step guide to validate your idea and create
                          a 30-day launch plan.
                        </p>
                        <ul>
                          <li class="ct_fs_16">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            Business Model Template
                          </li>
                          <li class="ct_fs_16">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            Launch Checklist
                          </li>
                          <li class="ct_fs_16">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            30-Day Focus Plan Workbook
                          </li>
                        </ul>
                        <div class="mt-3">
                          <a class="ct_hover_link_orange ct_yellow_text ct_fs_14">
                            Download eBook{" "}
                            <i class="fa-solid fa-arrow-right"></i>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                  <div class="item">
                    <figure class="mb-0 ct_coach_created_card">
                      <div
                        class="ct_coach_created_img"
                        style={{ aspectRatio: "auto" }}
                      >
                        <img src="assets/img/book_2.png" alt="" />
                      </div>
                      <figcaption class="mt-3">
                        <div class="d-flex align-items-center gap-2 justify-content-between mb-2">
                          <p class="mb-0 ct_fs_18">Lead with Vision</p>
                          <p class="mb-0 d-flex align-items-center gap-1">
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                          </p>
                        </div>
                        <p class="mt-1 mb-0 ct_fs_14 ct_darkblue_text ct_fw_600">
                          By Joe Bridges / Leadership Coach
                        </p>
                        <p class="mt-1 ct_fs_16">
                          ALearn how to clarify and communicate your vision to
                          inspire your team effectively.
                        </p>
                        <ul>
                          <li class="ct_fs_16">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            Vision Crafting Exercise
                          </li>
                          <li class="ct_fs_16">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            Communication Tips
                          </li>
                          <li class="ct_fs_16">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            Mindset Insights
                          </li>
                        </ul>
                        <div class="mt-3">
                          <a
                            href=""
                            class="ct_hover_link_orange ct_yellow_text ct_fs_14"
                          >
                            Download eBook{" "}
                            <i class="fa-solid fa-arrow-right"></i>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                  <div class="item">
                    <figure class="mb-0 ct_coach_created_card">
                      <div
                        class="ct_coach_created_img"
                        style={{ aspectRatio: "auto" }}
                      >
                        <img src="assets/img/book_3.png" alt="" />
                      </div>
                      <figcaption class="mt-3">
                        <div class="d-flex align-items-center gap-2 justify-content-between mb-2">
                          <p class="mb-0 ct_fs_18">Self-Mastery Essentials</p>
                          <p class="mb-0 d-flex align-items-center gap-1">
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                          </p>
                        </div>
                        <p class="mt-1 mb-0 ct_fs_14 ct_darkblue_text ct_fw_600">
                          By Nellie Padilla / Personal Coach
                        </p>
                        <p class="mt-1 ct_fs_16">
                          Unlock personal growth and self-awareness to enhance
                          resilience and overall well-being.
                        </p>
                        <ul>
                          <li class="ct_fs_16">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            Daily Reflection Journal
                          </li>
                          <li class="ct_fs_16">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            Prospecting Tips
                          </li>
                          <li class="ct_fs_16">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            Follow-Up Plan
                          </li>
                        </ul>
                        <div class="mt-3">
                          <a class="ct_hover_link_orange ct_yellow_text ct_fs_14">
                            Download eBook{" "}
                            <i class="fa-solid fa-arrow-right"></i>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                  <div class="item">
                    <figure class="mb-0 ct_coach_created_card">
                      <div
                        class="ct_coach_created_img"
                        style={{ aspectRatio: "auto" }}
                      >
                        <img src="assets/img/book_1.png" alt="" />
                      </div>
                      <figcaption class="mt-3">
                        <div class="d-flex align-items-center gap-2 justify-content-between mb-2">
                          <p class="mb-0 ct_fs_18">From Idea to Action</p>
                          <p class="mb-0 d-flex align-items-center gap-1">
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                            <i class="fa-solid fa-star ct_orange_text"></i>
                          </p>
                        </div>
                        <p class="mt-1 mb-0 ct_fs_14 ct_darkblue_text ct_fw_600">
                          By Jeffrey Walters / Founder Coach
                        </p>
                        <p class="mt-1 ct_fs_16">
                          A step-by-step guide to validate your idea and create
                          a 30-day launch plan.
                        </p>
                        <ul>
                          <li class="ct_fs_16">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            Business Model Template
                          </li>
                          <li class="ct_fs_16">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            Launch Checklist
                          </li>
                          <li class="ct_fs_16">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            30-Day Focus Plan Workbook
                          </li>
                        </ul>
                        <div class="mt-3">
                          <a class="ct_hover_link_orange ct_yellow_text ct_fs_14">
                            Download eBook{" "}
                            <i class="fa-solid fa-arrow-right"></i>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div> */}
              </div>
            </div>
          </section>
        )}
        <section
          class="ct_looking_for_work_bg ct_mt_100"
          style={{ paddingBlock: "100px" }}
          data-aos="fade-left"
          data-aos-duration="1500"
        >
          <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
            <div class="text-white">
              <h4 class="ct_fs_36 mb-3">
                Build Something Real With a Coach by Your Side
              </h4>
              <p class="mb-0 ct_fs_20">
                Transform your goals into reality with expert guidance every
                step of the way. From leadership growth to team performance,
                your coach helps you plan, act, and achieve with confidence.
              </p>
            </div>
            <div class="ct_flex_shrink_0">
              <a
                class="ct_yellow_btn ct_darkblue_btn ct_flex_1"
                onClick={() => navigate(coachPaths.FindCoach)}
              >
                Find Your Coach
              </a>
            </div>
          </div>
        </section>
        <section class=" ct_px_40 pt-0 ct_mt_100 ct_mb_100">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div
                class="col-xxl-6 col-xl-6 col-md-6 mb-4 mb-md-0"
                data-aos="fade-right"
                data-aos-duration="1500"
              >
                <div class="ct_about_cnt">
                  <h2 class="mb-5 ct_fs_40 ct_darksky_blue_text ">FAQs</h2>

                  <div class="ct_faq_question_main">
                    <div class="accordion" id="faq_accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faq_one">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_one"
                            aria-expanded="false"
                            aria-controls="collapsefaq_one"
                          >
                            What is CoachHUB?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_one"
                          class="accordion-collapse collapse"
                          aria-labelledby="faq_one"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-3 ct_line_h_30">
                              CoachHUB is a microsite within NUVIO that connects
                              companies with certified coaches while giving
                            </p>
                            <p class="ct_fs_20 mb-0 ct_line_h_30">
                              them a space to showcase their expertise, host
                              events, and grow their professional network.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faqtwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_Two"
                            aria-expanded="true"
                            aria-controls="collapseTwo"
                          >
                            How can my company get started ?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_Two"
                          class="accordion-collapse collapse "
                          aria-labelledby="faqtwo"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-3 ct_line_h_30">
                              Go to Find a Coach, explore profiles or programs,
                              and connect with the right coach for your business
                              goals. You can also create webinars, workshops, or
                              join Bootcamps for team development.
                            </p>
                            {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                              If you’re doing something new, on a bigger scale,
                              or need more flexibility, then Builder Studio is
                              for you. Prices vary depending on the features you
                              need but again, you’ll know exactly what you’re
                              paying upfront.
                            </p> */}
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faqthree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_Three"
                            aria-expanded="false"
                            aria-controls="collapsefaq_Three"
                          >
                            How do I become a coach on CoachHUB ?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_Three"
                          class="accordion-collapse collapse"
                          aria-labelledby="faqthree"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-3 ct_line_h_30">
                              Visit Become a Coach, complete your application,
                              and set up your professional profile. Once
                              approved, you can promote your services, organize
                              events, and sell your e-books or digital programs.
                            </p>
                            {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                              If you’re doing something new, on a bigger scale,
                              or need more flexibility, then Builder Studio is
                              for you. Prices vary depending on the features you
                              need but again, you’ll know exactly what you’re
                              paying upfront.
                            </p> */}
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faqFour">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_Four"
                            aria-expanded="false"
                            aria-controls="collapsefaq_Four"
                          >
                            Can I host or join events through CoachHUB ?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_Four"
                          class="accordion-collapse collapse"
                          aria-labelledby="faqFour"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-3 ct_line_h_30">
                              Yes! Companies and coaches can host or participate
                              in webinars and workshops to enhance visibility
                              and collaboration. Bootcamps, however, are
                              exclusively organised by the NUVIO team to foster
                              community growth, professional development, and
                              networking.
                            </p>
                            {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                              If you’re doing something new, on a bigger scale,
                              or need more flexibility, then Builder Studio is
                              for you. Prices vary depending on the features you
                              need but again, you’ll know exactly what you’re
                              paying upfront.
                            </p> */}
                          </div>
                        </div>
                      </div>

                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faqFive">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_Five"
                            aria-expanded="false"
                            aria-controls="collapsefaq_Five"
                          >
                            What support does NUVIO provide?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_Five"
                          class="accordion-collapse collapse"
                          aria-labelledby="faqFive"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-3 ct_line_h_30">
                              NUVIO offers ongoing support including visibility
                              across its network, marketing assistance for
                              events, and access to communities like CoachTalk,
                              Cross Group, and Learning Circles for
                              collaboration and growth.
                            </p>
                            {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                              If you’re doing something new, on a bigger scale,
                              or need more flexibility, then Builder Studio is
                              for you. Prices vary depending on the features you
                              need but again, you’ll know exactly what you’re
                              paying upfront.
                            </p> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-xxl-5  col-xl-6 col-md-6 mb-4 mb-md-0 "
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <div class="ct_about_img">
                  <img
                    src="assets/img/faq_img_22.png"
                    class="ct_img_h_617"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </MenuLayout>
    </div>
  );
};

export default WebinarLandingPage;
